import { rModelsBase } from './.catalog';

export class rProje extends rModelsBase {
  proje_adi: string;
  ince_yapi_isleri?: number;
  insaat_ilerleme_durumu?: number;
  kaba_yapi_isleri?: number;

  constructor() {
    super();
    this.proje_adi = '';
    this.ince_yapi_isleri = 0;
    this.insaat_ilerleme_durumu = 0;
    this.kaba_yapi_isleri = 0;
  }
}
